export const ComponentType = {
    MAIN_NAVIGATION: 'Main Navigation',
    MAIN_NAVIGATION_MENU: 'Main Navigation Menu',
    SUBNAVIGATION: 'Subnavigation',
    SUBNAVIGATION_MENU: 'Subnavigation Menu',
    IMAGE_SUBNAVIGATION: 'Image Subnavigation',
};
export const DESKTOP_BREAKPOINT = 1280;
// Constants used in CategoryFlattened
export const TIMEOUT_ENTER_DURATION = 100;
export const TIMEOUT_LEAVE_DURATION = 300;
